import React from 'react';
import OverviewMap from '../components/OverviewMap';
import OverviewTable from '../components/OverviewTable';

const OverviewPage = () => {
  return (
    <section className="overview">
      <div className="overview__card overview__card--fleet-position">
        <div className="overview__title">Fleet Position</div>
        <OverviewMap />
      </div>
      
      <div className="overview__card overview__card--fleet-details">
        <div className="overview__title">Fleet Details</div>
        <OverviewTable /> 
      </div>
    </section>
  )
};

export default OverviewPage;